import { render, staticRenderFns } from "./DecretosMovements.vue?vue&type=template&id=7753b8d9&scoped=true&"
import script from "./DecretosMovements.vue?vue&type=script&lang=js&"
export * from "./DecretosMovements.vue?vue&type=script&lang=js&"
import style0 from "./DecretosMovements.vue?vue&type=style&index=0&id=7753b8d9&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7753b8d9",
  null
  
)

export default component.exports